import React, { useEffect, useRef } from 'react';
import ChatMessage from './ChatMessage';
import { Spinner } from 'react-bootstrap';

const WelcomeMessage = () => (
  <div className="chat-welcome">
    <div className="chat-welcome-icon">🤖</div>
    <h5>RightSpade AI Assistant</h5>
    <p>Ask me about your portfolio, live market data, financial news, or risk analysis.</p>
    <div className="chat-suggestions">
      <span className="suggestion-chip">What is my portfolio P&amp;L?</span>
      <span className="suggestion-chip">Where is Nifty 50 today?</span>
      <span className="suggestion-chip">Any stop-loss risks in my holdings?</span>
      <span className="suggestion-chip">What's the market news today?</span>
    </div>
  </div>
);

const ChatMessageList = ({ messages, loading }) => {
  const bottomRef = useRef(null);

  // Auto-scroll to the latest message
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages, loading]);

  return (
    <div className="chat-message-list">
      {messages.length === 0 && !loading && <WelcomeMessage />}

      {messages.map((msg, idx) => (
        <ChatMessage key={idx} message={msg} />
      ))}

      {loading && (
        <div className="chat-message-wrapper assistant-message-wrapper">
          <div className="chat-avatar assistant-avatar">🤖</div>
          <div className="chat-bubble assistant-bubble chat-loading-bubble">
            <Spinner animation="grow" size="sm" className="me-1" />
            <Spinner animation="grow" size="sm" className="me-1" />
            <Spinner animation="grow" size="sm" />
          </div>
        </div>
      )}

      <div ref={bottomRef} />
    </div>
  );
};

export default ChatMessageList;
